<template>
	<div class="view" v-if="loaded">
		<div class="col chat">
			<!-- <ChatView
				:id="chat.id"
				:assigned="true"
				:assignedToMe="true"
				ref="chatview"
			/> -->
		</div>

		<div class="col video">
			<div class="remote">
				<video ref="remote" autoplay playsinline />
			</div>
			<div class="local">
				<video ref="local" autoplay playsinline muted />
			</div>
			<uiButton @click="startCall" style="margin-top: 20px">Начать</uiButton>
		</div>

		<div class="col pets" v-if="loaded">
			<h3>{{ user.surname }} {{ user.name }}<br />{{ user.midname }}</h3>
			<div class="info">{{ user.phone }}</div>
			<div class="info global-id">{{ user.id }}</div>

			<uiDevider />
			<div class="info" style="text-align: center" v-if="!pets.length">
				Нет питомцев
			</div>
			<template v-else>
				<uiDropdown
					:options="pets"
					v-model="pet"
					label="Питомец"
					optionsLabel="name"
					v-if="pets.length > 1"
				/>
				<PetCard v-if="pet" :id="pet.id" />
			</template>
		</div>
	</div>
</template>

<script>
import Repository from '@/repository'
import ChatView from '@/components/ChatView'
import PetCard from '@/components/PetCard'
import { API } from '@/config'
import { formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'

export default {
	name: 'CallPage',
	props: {
		id: String,
	},
	components: {
		ChatView,
		PetCard,
	},
	data() {
		return {
			loaded: false,
			loading: false,
			call: {},
			chat: null,
		}
	},
	computed: {
		chats() {
			return this.$store.getters.chats
		},
		pets() {
			if (!this.user) return
			return this.$store.getters.pets.filter((p) => this.user.pets.includes(p.id))
		},
		user() {
			if (!this.call) return
			return this.call.client
		},
		userAge() {
			return formatDistanceToNow(new Date(this.user.createdAt), {
				locale: ru,
			})
		},
	},
	activated() {
		this.loaded = false
		this.loadCall()
	},
	created() {
		this.$events.$on('chatAndTicketUpdated', this.chatAndTicketUpdated)
	},
	methods: {
		async loadCall() {
			if (this.loading) return
			this.loading = true

			let { data } = await this.$http.get(API.CALLS.get + this.id)
			if (!data || data.err) return this.$notify(data.err)
			this.call = data
			await Repository.loadPets(this.user.pets)
			if (this.pets.length) this.pet = this.pets[0]

			// let chat = this.chats.find((c) => c.id == this.id)
			// if (!chat) chat = await Repository.loadChat(this.id)
			// this.chat = chat

			this.loading = false
			this.loaded = true
			this.prepare()
			await this.prepareMedia()
		},
		async prepare() {
			this.channel = this.$pusher.subscribe('private-rtc-' + this.call.client.id)
			this.channel.bind('rtc-message', (e) => this.onMessage(e))
		},
		async prepareMedia() {
			let devices = await navigator.mediaDevices.enumerateDevices()
			this.videoEnabled = !!devices.find((d) => d.kind === 'videoinput')
			this.audioEnabled = !!devices.find((d) => d.kind === 'audioinput')
			this.constraints = {}

			if (this.videoEnabled) this.constraints.video = { facingMode: 'user' }
			if (this.audioEnabled) this.constraints.audio = { echoCancellation: true }

			let stream = await this.getLocalStream(this.constraints)
			this.$refs.local.srcObject = stream

			this.remoteStream = new MediaStream()
			this.$refs.remote.srcObject = this.remoteStream
		},
		async getLocalStream(constraints) {
			try {
				let stream = await navigator.mediaDevices.getUserMedia(constraints)
				this.localStream = stream
				if (this.peer) {
					this.localStream.getTracks().forEach((track) => {
						this.peer.addTrack(track, this.localStream)
					})
				}
				return stream
			} catch (err) {
				console.log(err)
				return null
			}
		},
		async startCall() {
			const configuration = {
				iceServers: [
					{
						urls: ['stun:ice.lapka.app'],
					},
					{
						urls: ['turn:ice.lapka.app'],
						username: this.name,
						credential: this.pass,
					},
				],
			}

			this.peer = new RTCPeerConnection(configuration)
			this.perr.addEventListener('icecandidate', (e) => {
				if (e.candidate) {
					this.channel.trigger('rtc-message', { candidate: e.candidate })
				}
			})

			this.peer.addEventListener('connectionstatechange', (e) => {
				if (this.peer.connectionState === 'connected') {
					this.connected = true
				} else {
					this.connected = false
				}
			})

			this.peer.addEventListener('track', async (e) => {
				this.remoteStream.addTrack(e.track, this.remoteStream)
			})

			this.localStream.getTracks().forEach((track) => {
				this.peer.addTrack(track, this.localStream)
			})

			const offer = await this.peer.createOffer()
			await this.peer.setLocalDescription(offer)
			this.channel.trigger('rtc-message', { offer: offer })
		},
		async onMessage(e) {
			if (e.answer) {
				const remoteDesc = new RTCSessionDescription(e.answer)
				await this.peer.setRemoteDescription(remoteDesc)
			}
			if (e.candidate) {
				try {
					await this.peer.addIceCandidate(e.candidate)
				} catch (e) {
					console.error('Error adding received ice candidate', e)
				}
			}
			if (e.call) {
				this.startCall()
			}
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
	display: flex;
	justify-content: center;
}

.col {
	width: 270px;
	margin: 0 15px;
	margin-top: 30px;
}

.video {
	width: 400px;
	position: relative;

	.remote {
		width: 400px;
		height: 700px;
		background: #000;
		border-radius: 20px;
	}

	.local {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 100px;
		height: 150px;
		overflow: hidden;
		border-radius: 10px;
		box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);

		video {
			height: 100%;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
		}
	}
}
</style>
